/* eslint-disable import/no-anonymous-default-export */
export default{
    baseurl:"https://dentectiveapi.dev-sh.xyz/api",
}